/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ExternalKeySummary,
  ExternalKeySummary$inboundSchema,
} from "./externalkeysummary.js";

export type ListExternalKeysResult = {
  /**
   * The organization's external keys.
   */
  keys: Array<ExternalKeySummary>;
};

/** @internal */
export const ListExternalKeysResult$inboundSchema: z.ZodMiniType<
  ListExternalKeysResult,
  unknown
> = z.object({
  keys: z.array(ExternalKeySummary$inboundSchema),
});

export function listExternalKeysResultFromJSON(
  jsonString: string,
): SafeParseResult<ListExternalKeysResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListExternalKeysResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListExternalKeysResult' from JSON`,
  );
}
